import {isNullOrEmpty} from "@2d-front-monorepo/core";
import AddressUses from "./enums/AddressUses.js";
import {Address} from "./types/Address";
import {QueryAddressResult} from "./types/QueryAddressResult.js";

class Addresses {
	static getByUses(addresses: QueryAddressResult[], uses: AddressUses): QueryAddressResult[] {
		return addresses.filter((x) => (x.uses & uses) === uses);
	}

	static hasMinimalData(address: Address): boolean {
		return !isNullOrEmpty(address.street) && !isNullOrEmpty(address.streetNumber)
	}
}

export {Addresses};
